import ChatBodyHeader from "./ChatBodyHeader";

export default ChatBodyHeader;
